import { useEffect, useState } from "react";
import { get } from "./api.js";
export { MAX_FILE_SEARCH_LENGTH } from "@wmf/shared/teachingAssetLimits";

export interface LibraryItem {
  source: "resource" | "school-resource" | "lesson" | "school";
  id: string;
  title: string;
  description: string | null;
  fileName: string;
  fileType: string | null;
  fileSize: number | null;
  kind: string;
  externalUrl: string | null;
  repertoireEligible?: boolean;
  reusableCopyEligible?: boolean;
  bulkRepertoireEligible?: boolean;
  reuseVersion?: string;
  shareable?: boolean;
  context: string;
  createdAt: string;
  copies?: LibraryItem[];
  usageLabel?: string;
  lessonCount?: number;
}
export interface LibraryPage { items: LibraryItem[]; nextOffset: number | null; storageConfigured: boolean; duplicateChecksUnavailable?: boolean }
export type LibraryView = "mine" | "all";
/** `student:<id>` or `pupil:<id>` limits results to files that pupil's note may use. */
export function useFileLibrary(q: string, kind = "all", offset = 0, documentsOnly = false, revision = 0, enabled = true, scope?: string, view?: LibraryView, sort?: "recent" | "title", groupDuplicates = false) {
  const key = JSON.stringify([q, kind, offset, documentsOnly, revision, enabled, scope, view, sort, groupDuplicates]);
  const [state, setState] = useState<{ key: string; data?: LibraryPage; error?: string }>({ key: "" });
  useEffect(() => {
    if (!enabled) return;
    let current = true;
    const timer = window.setTimeout(() => {
      get<LibraryPage>("/files", { q, kind, offset: String(offset), documentsOnly: String(documentsOnly), ...(scope ? { for: scope } : {}), ...(view ? { view } : {}), ...(sort ? { sort } : {}), ...(groupDuplicates ? { groupDuplicates: "true" } : {}) })
        .then(data => { if (current) setState({ key, data }); })
        .catch((error: unknown) => { if (current) setState({ key, error: error instanceof Error ? error.message : "Could not search files." }); });
    }, 250);
    return () => { current = false; window.clearTimeout(timer); };
  }, [key]);
  // Invalidate synchronously: a previous query must never leave clickable stale results.
  const active = state.key === key ? state : undefined;
  return { data: active?.data, error: active?.error, loading: enabled && !active };
}
export function libraryOpenUrl(item: LibraryItem) {
  return `/api/files/${item.source}/${encodeURIComponent(item.id)}/open`;
}
